import { Component, h } from 'preact'
import axios from 'axios'
import CategoryListItem from './CategoryListItem'

type Category = {
  id: number,
  title: string
}

interface Props {
  id: number
}

interface State {
  list: Array<Category>
}

class CategoryList extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      list: []
    }
  }

  async componentDidMount () {
    const { data } = await axios.get('/category/list', {
      params: {
        id: this.props.id
      }
    })

    this.setState({ list: data })
  }

  render (props: Props, { list }: State) {
    const displayList = list
    return (
      <div className='category-page_container'>
        <ul className='category-page_list'>
          {
            displayList.map((item) => <CategoryListItem {...item} />)
          }
        </ul>
      </div>
    )
  }
}

export default CategoryList
